export default __webpack_public_path__ + "assets/fd382ead0b9abda806846d0d453c8a88.svg";